var map = {
	"./batareya_otopleniya.svg": "ca58",
	"./boyler.svg": "7dea",
	"./obogrevatel_elektricheskiy.svg": "0849",
	"./sushilka_dlya_ruk.svg": "edc9",
	"./vytyazhka.svg": "64c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9656";